import {
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    Output,
    AfterViewInit,
    inject
} from "@angular/core";
import { Subscription } from "rxjs";

@Directive({
    selector: "[uzunBas]",
    standalone: true,
})
export class UzunBasDirective implements OnDestroy, AfterViewInit {
    private eventSubscribe!: Subscription;
    threshold = 1000;
    private elementRef = inject(ElementRef);
    private touchStartListener: (() => void) | null = null;
    private touchMoveListener: (() => void) | null = null;
    private isProcessing = false; // Prevent multiple simultaneous executions

    // Hareket toleransı - piksel cinsinden (küçük titremeleri yoksay)
    private readonly HAREKET_TOLERANSI = 15;
    private baslangicX = 0;
    private baslangicY = 0;
    private hareketTakibiAktif = false;

    // @Output()
    // uzunBasildi = new EventEmitter();

    constructor() {
        // const mousedown = fromEvent<MouseEvent>(elementRef.nativeElement, "mousedown").pipe(
        //     filter(event => event.button == 0),  // Only allow left button (Primary button)
        //     map((event) => true) // turn on threshold counter
        // );
        // const touchstart = fromEvent(elementRef.nativeElement, 'touchstart').pipe(map(() => true));
        // const touchEnd = fromEvent(elementRef.nativeElement, 'touchend').pipe(map(() => false));
        // const mouseup = fromEvent<MouseEvent>(window, "mouseup").pipe(
        //     filter(event => event.button == 0),  // Only allow left button (Primary button)
        //     map(() => false) // reset threshold counter
        // );
        // this.eventSubscribe = merge(mousedown, mouseup, touchstart, touchEnd)
        //     .pipe(
        //         switchMap(state =>
        //             state ? timer(this.threshold, 100) : of(null)
        //         ),
        //           filter(value => value as any)
        //     )
        //     .subscribe(() => this.uzunBasildi.emit());
    }


    ngAfterViewInit(): void {
        // Passive touchstart listener to improve performance
        const touchStartHandler = (e: TouchEvent) => this.onTouchstart(e);
        this.elementRef.nativeElement.addEventListener('touchstart', touchStartHandler, { passive: true });
        this.touchStartListener = () => {
            this.elementRef.nativeElement.removeEventListener('touchstart', touchStartHandler);
        };

        // Passive touchmove listener to improve performance (replaces @HostListener)
        const touchMoveHandler = (e: TouchEvent) => this.onTouchmove(e);
        this.elementRef.nativeElement.addEventListener('touchmove', touchMoveHandler, { passive: true });
        this.touchMoveListener = () => {
            this.elementRef.nativeElement.removeEventListener('touchmove', touchMoveHandler);
        };
    }

    ngOnDestroy(): void {
        if (this._timeout) {
            clearTimeout(this._timeout);
        }
        if (this.eventSubscribe) {
            this.eventSubscribe.unsubscribe();
        }
        if (this.touchStartListener) {
            this.touchStartListener();
        }
        if (this.touchMoveListener) {
            this.touchMoveListener();
        }
        this.isProcessing = false;
    }

    @Output()
    uzunBasildi = new EventEmitter();

    @Input()
    uzunBasSure = 500;

    private _timeout: any;

    @HostListener('pointerdown', ['$event']) onMouseDown(e: PointerEvent) {
        if (this._timeout)
            clearTimeout(this._timeout);

        if (e.button == 0) {
            // Başlangıç pozisyonunu kaydet
            this.baslangicX = e.clientX;
            this.baslangicY = e.clientY;
            this.hareketTakibiAktif = true;

            this._timeout = setTimeout(() => {
                // Prevent multiple simultaneous executions
                if (this.isProcessing) return;
                this.isProcessing = true;
                this.hareketTakibiAktif = false;

                // Use requestAnimationFrame for non-blocking execution
                requestAnimationFrame(() => {
                    try {
                        this.uzunBasildi.emit(e);
                    } finally {
                        // Reset processing flag after emission completes
                        setTimeout(() => {
                            this.isProcessing = false;
                        }, 50); // Small delay to prevent rapid-fire executions
                    }
                });
            }, this.uzunBasSure);
        }
    }

    onTouchstart(e: TouchEvent) {
        if (this._timeout)
            clearTimeout(this._timeout);

        // Başlangıç pozisyonunu kaydet (touch için)
        if (e.touches.length > 0) {
            this.baslangicX = e.touches[0].clientX;
            this.baslangicY = e.touches[0].clientY;
            this.hareketTakibiAktif = true;
        }

        this._timeout = setTimeout(() => {
            // Prevent multiple simultaneous executions
            if (this.isProcessing) return;
            this.isProcessing = true;
            this.hareketTakibiAktif = false;

            // Use requestAnimationFrame for non-blocking execution
            requestAnimationFrame(() => {
                try {
                    this.uzunBasildi.emit(e);
                } finally {
                    // Reset processing flag after emission completes
                    setTimeout(() => {
                        this.isProcessing = false;
                    }, 50); // Small delay to prevent rapid-fire executions
                }
            });
        }, this.uzunBasSure);
    }

    @HostListener('pointermove', ['$event']) onPointermove(e: PointerEvent) {
        // Sadece hareket takibi aktifse kontrol et
        if (!this.hareketTakibiAktif || !this._timeout) return;

        // Hareketin tolerans sınırını aşıp aşmadığını kontrol et
        const deltaX = Math.abs(e.clientX - this.baslangicX);
        const deltaY = Math.abs(e.clientY - this.baslangicY);

        // Sadece tolerans aşıldığında timeout'u iptal et
        if (deltaX > this.HAREKET_TOLERANSI || deltaY > this.HAREKET_TOLERANSI) {
            clearTimeout(this._timeout);
            this._timeout = null;
            this.hareketTakibiAktif = false;
        }
    }


    @HostListener('touchend') onTouchend() {
        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
        this.hareketTakibiAktif = false;
    }

    @HostListener('mouseup') onMouseUp() {
        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
        this.hareketTakibiAktif = false;
    }

    @HostListener('mouseleave') onMouseLeave() {
        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
        this.hareketTakibiAktif = false;
    }

    // Passive touchmove handler (called from ngAfterViewInit listener)
    onTouchmove(e: TouchEvent) {
        // Sadece hareket takibi aktifse kontrol et
        if (!this.hareketTakibiAktif || !this._timeout || e.touches.length === 0) return;

        // Hareketin tolerans sınırını aşıp aşmadığını kontrol et
        const deltaX = Math.abs(e.touches[0].clientX - this.baslangicX);
        const deltaY = Math.abs(e.touches[0].clientY - this.baslangicY);

        // Sadece tolerans aşıldığında timeout'u iptal et
        if (deltaX > this.HAREKET_TOLERANSI || deltaY > this.HAREKET_TOLERANSI) {
            clearTimeout(this._timeout);
            this._timeout = null;
            this.hareketTakibiAktif = false;
        }
    }
}